module.exports = __webpack_public_path__ + "static/media/plan-speed.8823d659.svg";